import { Button } from "@/components/ui/button";
import { FileDown, X } from "lucide-react";

/**
 * Inline prompt shown inside the Save/Update dialog after a successful
 * save/update (and optional barcode tag). Asks the user whether they want
 * to export the costing sheet as PDF before the dialog closes.
 */
export default function PdfPromptStep({ onExport, onSkip, exporting = false }) {
  return (
    <div className="space-y-4 py-1" data-testid="pdf-prompt-step">
      <p className="text-sm text-stone-600 text-center">
        Design is ready. Would you like to download the costing sheet as PDF?
      </p>
      <div className="flex gap-2 pt-1">
        <Button
          variant="outline"
          className="flex-1"
          onClick={onSkip}
          data-testid="pdf-prompt-skip"
          disabled={exporting}
        >
          <X className="h-4 w-4 mr-2" /> Skip
        </Button>
        <Button
          className="flex-1 bg-[#C2410C] hover:bg-[#9A3412] text-white"
          onClick={onExport}
          data-testid="pdf-prompt-export"
          disabled={exporting}
        >
          <FileDown className="h-4 w-4 mr-2" /> {exporting ? "Exporting..." : "Export PDF"}
        </Button>
      </div>
    </div>
  );
}
